import React from 'react'
import { MerchantLocationsLoader } from 'router/Loaders'
import { ManageIntegrations } from 'components/Integrations/Manage'
import {
  IntegrationContext,
  SetupIntegration
} from 'components/Integrations/hooks/useIntegration'
import IntegrationModuleLoaders from 'components/Integrations/Loaders'

export const ManageIntegrationsWrapper = () => {
  return (
    <IntegrationContext.Provider value={SetupIntegration()}>
      <MerchantLocationsLoader>
        {(isParentLoaded) => (
          <IntegrationModuleLoaders isParentLoaded={isParentLoaded}>
            <ManageIntegrations />
          </IntegrationModuleLoaders>
        )}
      </MerchantLocationsLoader>
    </IntegrationContext.Provider>
  )
}
